import React from "react";
import { Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import DocumentStatusTable from "./DocumentStatusTable";

function DocCenter() {
  return (
    <Grid container spacing={3} sx={{ padding: "20px" }}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ color: "#00f5d4", marginBottom: "10px" }}>
           Document Submission Status
        </Typography>
        <DocumentStatusTable />
      </Grid>
    </Grid>
  );
}

export default DocCenter;
